
import md5 from 'js-md5'
//========================localStorage=====================================
//储存数据
function setSessData(key, obj) {
  if (typeof obj === "object") {
    obj = JSON.stringify(obj); //json对象,stringify()将obj转换为string类型
  }
  sessionStorage.setItem(key, obj); //localStorage只能存储字符串类型，所以就必须转为string.
};
//获取存储的数据
function getSessData(key) {
  let data;
  try {
    var obj = sessionStorage.getItem(key); //获取存储数据
    data = JSON.parse(obj); //将OBJ转为JSON
  } catch (event) {
    data = obj;
  }
  return data;
};
//删除指定的存储
function delSessData(key) {
  sessionStorage.removeItem(key);
};

//========================localStorage===================================
//储存数据
function setLocaData(key, obj) {
  if (typeof obj === "object") {
    obj = JSON.stringify(obj); //json对象,stringify()将obj转换为string类型
  }
  localStorage.setItem(key, obj); //localStorage只能存储字符串类型，所以就必须转为string.
};

//获取存储的数据
function getLocaData(key) {
  let data;
  try {
    var obj = localStorage.getItem(key); //获取存储数据
    data = JSON.parse(obj); //将OBJ转为JSON
  } catch (event) {
    data = obj;
  }
  return data;
};

//删除指定的存储
function delLocaData(key) {
  localStorage.removeItem(key);
};

// 隐藏手机中间四位
function hidePhone(phone) {
  if (phone) {
    phone = phone.toString();
    let a = phone.substring(0, 3);
    let b = phone.substring(phone.length - 4, phone.length);
    let newPhone = a + "****" + b
    return newPhone
  } else {
    return "暂无数据"
  }
};

// 隐藏姓名
function hideName(name) {
  if (name) {
    name = name.toString();
    var firstName = name.substring(0, 1);
    var lastName = "";
    for (var i = 0; i < name.length - 1; i++) {
      lastName += '*';
    }
    let newName = firstName + lastName;
    return newName
  } else {
    return "暂无数据"
  }
};

//显示第一个和最后一个数字
function showFirstLast(code) {
  var firstCode = code.substring(0, 1);
  var middleCode = "";
  for (var i = 0; i < code.length - 1; i++) {
    middleCode += '*';
  }
  var lastCode = code.substring(code.length - 1, code.length);
  let newCode = firstCode + middleCode + lastCode;
  return newCode
};
//显示后四位
function showFore(code) {
  var newCode = code.substring(code.length - 4, code.length);
  return newCode
};
//乘法
function accMul(arg1, arg2) {
  if (arg1 && arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) { }
    try {
      m += s2.split(".")[1].length
    } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
  } else {
    return 0
  }
}
//乘法 舍掉小数点后面的
function accMuls(arg1, arg2) {
  if (arg1 && arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) { }
    try {
      m += s2.split(".")[1].length
    } catch (e) { }
    var s3 = Number(((Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)).toString()).split('.')[0])
    return s3
  } else {
    return 0
  }
}
//除法
function addMul(arg1, arg2) {
  if (arg1 && arg2) {
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) { }
    try {
      m += s2.split(".")[1].length
    } catch (e) { }
    if (s1.split('.').length > 1 && s1.split('.')[1].length > 1) {
      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(1000, m)
    } else {
      return (Number(arg1) / 100)
    }
  } else {
    return 0
  }
}

//时间戳转日期格式 没有时分秒
function formatTime(time) {
  let now = new Date(time);
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var date = now.getDate();

  if (month < 10) {
    month = "0" + month
  }

  if (date < 10) {
    date = "0" + date
  }
  return year + "-" + month + "-" + date;
}

//时间戳转日期格式有时分秒
function formatTimes(time) {
  let now = new Date(time);
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  if (month < 10) {
    month = "0" + month
  }
  var date = now.getDate();
  if (date < 10) {
    date = "0" + date
  }
  var hour = now.getHours();
  if (hour < 10) {
    hour = "0" + hour
  }
  var minute = now.getMinutes();
  if (minute < 10) {
    minute = "0" + minute
  }
  var second = now.getSeconds();
  if (second < 10) {
    second = "0" + second
  }
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}

//获取AddDayCount天后的日期，不包括当前日期所以+1
export function GetDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount + 1);
  var y = dd.getFullYear();
  var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0  
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0  

  return y + "-" + m + "-" + d;
}

//选择日期获取N年后的前一天
export function oneYearPast(obj, n) {
  let time = new Date(obj)
  let year = time.getFullYear() + 1;
  let month = time.getMonth() + 1;
  let day = time.getDate();
  if (month < 10) {
    month = "0" + month;
  }

  if (day > 1) {
    day = day - 1;
  } else {
    month = month - 1;
    if (month < 10) {
      month = "0" + month;
    }
    if (month == 0) {
      month = 12;
    }
    day = new Date(year, month, 0).getDate();
  }

  let v2 = year + '-' + month + '-' + (day < 10 ? '0' + day : day);
  return v2;
}

function debounce(fn, wait = 1000) {
  var timeout = null;
  return function () {
    if (timeout !== null)
      clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  }
}

/**
根据身份证号码判断性别
15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日
18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，
第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
*/
//根据身份证号获取年龄
function getAge(identityCard) {
  var len = (identityCard + "").length;
  var strBirthday = "";
  if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
  {
    strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
  }
  if (len == 15) {
    var birthdayValue = '';
    birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
    if (parseInt(birthdayValue) < 10) {
      strBirthday = "20" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
    } else {
      strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
    }

  }
  //时间字符串里，必须是“/”
  var birthDate = new Date(strBirthday);
  var nowDateTime = new Date();
  var age = nowDateTime.getFullYear() - birthDate.getFullYear();
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

function throttle(func, delay) {
  var prev = Date.now();
  return function () {
    var context = this;
    var args = arguments;
    var now = Date.now();
    if (now - prev >= delay) {
      func.apply(context, args);
      prev = Date.now();
    }
  }
}

function isIphonex() {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
  }
  return false;
};

//md5加密
function md5s(val) {
  return md5(val).toLowerCase()
}

function gologin(){
   this.$router.push('./')
}
export {
  setSessData,
  getSessData,
  delSessData,
  setLocaData,
  getLocaData,
  delLocaData,
  hidePhone,
  hideName,
  showFirstLast,
  showFore,
  accMul,
  addMul,
  accMuls,
  md5s,
  formatTime,
  formatTimes,
  debounce,
  throttle,
  getAge,
  isIphonex,
  gologin
}
